import { type ReactNode } from 'react';
import { FieldInput } from '@/components/ui/field-input';
import { type FieldProps, field } from './signup-field-helpers';
import {
  ContactFields,
  LocationRow,
  NameRow,
  PhoneRow,
} from './personal-field-rows';

export function PersonalFields(p: FieldProps): ReactNode {
  return (
    <>
      <NameRow {...p} />
      <ContactFields {...p} />
      <PhoneRow {...p} />
      <LocationRow {...p} />
      <FieldInput
        type="date"
        label="Fecha de nacimiento"
        value={p.data.birthdate}
        onChange={field(p.data, p.onChange, 'birthdate')}
        error={p.errors?.birthdate}
      />
    </>
  );
}
